"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEmptyActivities = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseEmptyActivities(processData) {
    const emptyActivitiesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.EmptyActivity);
    const noEmptyActivitiesFound = !((emptyActivitiesRaw === null || emptyActivitiesRaw === void 0 ? void 0 : emptyActivitiesRaw.length) > 0);
    if (noEmptyActivitiesFound) {
        return [];
    }
    const emptyActivities = emptyActivitiesRaw.map((emptyActivityRaw) => {
        const flowNodeId = emptyActivityRaw.id;
        try {
            return parseEmptyActivity(emptyActivityRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return emptyActivities;
}
exports.parseEmptyActivities = parseEmptyActivities;
function parseEmptyActivity(emptyActivityRaw) {
    const emptyActivity = (0, ActivityFactory_1.createActivityInstance)(emptyActivityRaw, index_1.Model.Activities.EmptyActivity);
    setEnabled(emptyActivity);
    return emptyActivity;
}
function setEnabled(emptyActivity) {
    var _a, _b;
    const enabled = (_b = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('enabled', emptyActivity.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 'true';
    emptyActivity.enabled = enabled === 'true';
}
//# sourceMappingURL=EmptyActivityParser.js.map